var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye-outline")]), _vm._v(" Visualizar Notificação ")], 1)]), _c('div', {
    staticClass: "container dialog mt-7"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Assunto da Notificação",
      "dense": "",
      "outlined": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.assunto,
      callback: function ($$v) {
        _vm.$set(_vm.content, "assunto", $$v);
      },
      expression: "content.assunto"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Notificação",
      "rows": "3",
      "dense": "",
      "outlined": "",
      "disabled": ""
    },
    model: {
      value: _vm.content.notificacao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "notificacao", $$v);
      },
      expression: "content.notificacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Grupo(s)")]), _c('div', {
    staticClass: "grupos-box"
  }, [_c('v-chip-group', {
    attrs: {
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l(_vm.content.grupos, function (grupo) {
    return _c('v-chip', {
      key: grupo.id
    }, [_vm._v(" " + _vm._s(grupo.nome) + " ")]);
  }), 1)], 1)])], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }